<template>
  <div class="makeweici-model">
    <!-- 科技感加载动画 -->
    <AiLoading :visible="loading" title="系统正在构建专属资产配置方案"></AiLoading>

    <div class="model-content">
      <div class="right-panel">
        <h3 class="panel-title">| 实时配置权重预览</h3>

        <div class="preview-content">
          <div class="preview-column">
            <div class="column-header">
              <span class="column-title">模型数学结果（理论组合）</span>
              <span class="status-badge error">
                <svg width="10" height="10" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 5L2 43H46L24 5Z" fill="none" stroke="#df0916"
                        stroke-width="4" stroke-linejoin="round" />
                  <path d="M24 35V36" stroke="#df0916" stroke-width="4" stroke-linecap="round" />
                  <path d="M24 19.0005L24.0083 29" stroke="#df0916" stroke-width="4" stroke-linecap="round" />
                </svg>
                超出风险承受范围
              </span>
            </div>
            <div class="desc">仅供参考，不可直接采用</div>
            <div class="donut-row">
              <div class="donut-chart-container">
                <svg viewBox="0 0 100 100" class="donut-chart">
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#e2e8f0" stroke-width="14" />
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#3b82f6" stroke-width="14"
                          :stroke-dasharray="2 * Math.PI * 38"
                          :stroke-dashoffset="2 * Math.PI * 38 * (1 - weights.stock / 100)"
                          transform="rotate(-90 50 50)" />
                </svg>
                <div class="donut-center">{{ weights.stock }}%</div>
              </div>
              <div class="donut-chart-container">
                <svg viewBox="0 0 100 100" class="donut-chart">
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#e2e8f0" stroke-width="14" />
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#10b981" stroke-width="14"
                          :stroke-dasharray="2 * Math.PI * 38"
                          :stroke-dashoffset="2 * Math.PI * 38 * (1 - weights.bond / 100)"
                          transform="rotate(-90 50 50)" />
                </svg>
                <div class="donut-center">{{ weights.bond }}%</div>
              </div>
              <div class="donut-chart-container">
                <svg viewBox="0 0 100 100" class="donut-chart">
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#e2e8f0" stroke-width="14" />
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#f59e0b" stroke-width="14"
                          :stroke-dasharray="2 * Math.PI * 38"
                          :stroke-dashoffset="2 * Math.PI * 38 * (1 - weights.fund / 100)"
                          transform="rotate(-90 50 50)" />
                </svg>
                <div class="donut-center">{{ weights.fund }}%</div>
              </div>
            </div>
            <div class="weight-bar-stacked">
              <div class="weight-bar-track">
                <div class="weight-bar-segment stock" :style="{ width: weights.stock + '%' }"></div>
                <div class="weight-bar-segment bond" :style="{ width: weights.bond + '%' }">
                </div>
                <div class="weight-bar-segment fund" :style="{ width: weights.fund + '%' }">
                </div>
              </div>
              <div class="weight-bar-labels">
                <span class="weight-bar-label">
                  <span class="label-dot stock"></span>股票 {{ weights.stock }}%
                </span>
                <span class="weight-bar-label">
                  <span class="label-dot bond"></span>债券 {{ weights.bond }}%
                </span>
                <span class="weight-bar-label">
                  <span class="label-dot fund"></span>基金 {{ weights.fund }}%
                </span>
              </div>
            </div>
          </div>

          <div class="compliance-arrow">
            <div class="arrow-dashes"></div>
            <div class="arrow-content">
              <div class="arrow-icon">
                <svg t="1782112775495" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="8366" width="28" height="28">
                  <path d="M389.6 183.5l569.8 329-569.8 329V662.8H65.5V362.4h324.1z" fill="#548cf6" p-id="8367"></path>
                </svg>
              </div>
              <span class="arrow-text">合规裁剪</span>
            </div>
          </div>

          <div class="preview-column">
            <div class="column-header">
              <span class="column-title">合规裁剪后实际推荐</span>
              <span class="status-badge success">
                <svg width="10" height="10" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 44C29.5228 44 34.5228 41.7614 38.1421 38.1421C41.7614 34.5228 44 29.5228 44 24C44 18.4772 41.7614 13.4772 38.1421 9.85786C34.5228 6.23858 29.5228 4 24 4C18.4772 4 13.4772 6.23858 9.85786 9.85786C6.23858 13.4772 4 18.4772 4 24C4 29.5228 6.23858 34.5228 9.85786 38.1421C13.4772 41.7614 18.4772 44 24 44Z"
                        fill="none" stroke="#0ab15b" stroke-width="4" stroke-linejoin="round" />
                  <path d="M16 24L22 30L34 18" stroke="#0ab15b" stroke-width="4" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                可直接采用
              </span>
            </div>
            <div class="desc">符合您的风险等级约束</div>
            <div class="donut-row">
              <div class="donut-chart-container">
                <svg viewBox="0 0 100 100" class="donut-chart">
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#e2e8f0" stroke-width="14" />
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#3b82f6" stroke-width="14"
                          :stroke-dasharray="2 * Math.PI * 38"
                          :stroke-dashoffset="2 * Math.PI * 38 * (1 - compliancePreview.compliantWeights.stock / 100)"
                          transform="rotate(-90 50 50)" />
                </svg>
                <div class="donut-center">{{ compliancePreview.compliantWeights.stock }}%</div>
              </div>
              <div class="donut-chart-container">
                <svg viewBox="0 0 100 100" class="donut-chart">
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#e2e8f0" stroke-width="14" />
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#10b981" stroke-width="14"
                          :stroke-dasharray="2 * Math.PI * 38"
                          :stroke-dashoffset="2 * Math.PI * 38 * (1 - compliancePreview.compliantWeights.bond / 100)"
                          transform="rotate(-90 50 50)" />
                </svg>
                <div class="donut-center">{{ compliancePreview.compliantWeights.bond }}%</div>
              </div>
              <div class="donut-chart-container">
                <svg viewBox="0 0 100 100" class="donut-chart">
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#e2e8f0" stroke-width="14" />
                  <circle cx="50" cy="50" r="38" fill="none" stroke="#f59e0b" stroke-width="14"
                          :stroke-dasharray="2 * Math.PI * 38"
                          :stroke-dashoffset="2 * Math.PI * 38 * (1 - compliancePreview.compliantWeights.fund / 100)"
                          transform="rotate(-90 50 50)" />
                </svg>
                <div class="donut-center">{{ compliancePreview.compliantWeights.fund }}%</div>
              </div>
            </div>
            <div class="weight-bar-stacked">
              <div class="weight-bar-track">
                <div class="weight-bar-segment stock"
                     :style="{ width: compliancePreview.compliantWeights.stock + '%' }"></div>
                <div class="weight-bar-segment bond" :style="{ width: compliancePreview.compliantWeights.bond + '%' }">
                </div>
                <div class="weight-bar-segment fund" :style="{ width: compliancePreview.compliantWeights.fund + '%' }">
                </div>
              </div>
              <div class="weight-bar-labels">
                <span class="weight-bar-label">
                  <span class="label-dot stock"></span>股票 {{ compliancePreview.compliantWeights.stock }}%
                </span>
                <span class="weight-bar-label">
                  <span class="label-dot bond"></span>债券 {{ compliancePreview.compliantWeights.bond }}%
                </span>
                <span class="weight-bar-label">
                  <span class="label-dot fund"></span>基金 {{ compliancePreview.compliantWeights.fund }}%
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="compliancePreview.triggered" class="compliance-tips">
          <div class="tip-icon">⚠</div>
          <div class="tip-content">
            <div class="tip-title">合规提示</div>
            <div class="tip-text">{{ compliancePreview.message }}</div>
            <div class="tip-text">{{ compliancePreview.redistributionNote }}</div>
          </div>
        </div>

        <div class="metrics-cards">
          <div class="metric-card blue">
            <div class="metric-label">组合预期收益率（%）</div>
            <div class="metric-value metric-value-blue">{{ metrics.portfolioReturn }}%</div>
          </div>
          <div class="metric-card green">
            <div class="metric-label">组合波动率（%）</div>
            <div class="metric-value metric-value-green">{{ metrics.portfolioVolatility }}%</div>
          </div>
          <div class="metric-card orange">
            <div class="metric-label">夏普比率</div>
            <div class="metric-value metric-value-orange">{{ metrics.sharpeRatio }}</div>
          </div>
        </div>

      </div>

      <div class="left-panel">
        <div class="panel-header">
          <h3 class="panel-title">| 参数控制面板</h3>
          <span class="risk-rating">
            <svg class="rating-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
            当前评级：{{ currentRating.code }}（{{ currentRating.label }}）
          </span>
        </div>

        <div class="parameter-group">
          <div class="parameter-item" v-if="showRiskFreeRate">
            <div class="parameter-header">
              <span class="parameter-name">无风险利率</span>
              <span class="parameter-value">{{ riskFreeRate }}%</span>
            </div>
            <div class="slider-container">
              <el-slider v-model="riskFreeRate" id="slider-risk-free-rate-model" :min="0" :max="5" :step="0.1"
                         input-size="small" @change="updateAllocations"></el-slider>
              <div class="slider-labels">
                <span>0%</span>
                <span>5%</span>
              </div>
            </div>
          </div>

          <div class="parameter-item" v-if="showStockReturn">
            <div class="parameter-header">
              <span class="parameter-name">股票预期收益率</span>
              <span class="parameter-value">{{ stockReturn }}%</span>
            </div>
            <div class="slider-container">
              <el-slider v-model="stockReturn" id="slider-stock-return-model" :min="-10" :max="20" :step="0.5"
                         input-size="small" @change="updateAllocations"></el-slider>
              <div class="slider-labels">
                <span>-10%</span>
                <span>20%</span>
              </div>
            </div>
          </div>

          <div class="parameter-item" v-if="showRiskAversion">
            <div class="parameter-header">
              <span class="parameter-name">风险厌恶系数（1 = 激进 / 10 = 保守）</span>
              <span class="parameter-value">{{ riskAversion }} ({{ riskAversionLabel }})</span>
            </div>
            <div class="slider-container">
              <el-slider v-model="riskAversion" id="slider-risk-aversion-model" :min="1" :max="10" :step="0.5"
                         input-size="small" @change="updateAllocations"></el-slider>
              <div class="slider-labels">
                <span>1 (激进)</span>
                <span>10 (保守)</span>
              </div>
            </div>
          </div>

          <div class="parameter-item" v-if="activeTab == 'EqualWeight'">
            <p>本模型无需手动配置，即可计算</p>
          </div>
          <div class="parameter-item" v-if="activeTab == 'MinVariance'">
            <p>调整无风险利率只会改变夏普比率显示，权重永远不变</p>
          </div>

        </div>

        <div class="parameter-note">
          <span class="note-icon">注：</span>参数调整将实时更新左侧的理论结果与合规推荐。
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import apiOpen from '@/api/open'
import AiLoading from '@/components/AiLoading.vue'

export default {
  name: 'MakeweiciModel',
  components: {
    AiLoading
  },
  props: {
    activeTab: {
      type: String,
      default: 'MeanVariance'
    }
  },
  data () {
    return {
      riskFreeRate: 0,
      stockReturn: -10,
      riskAversion: 1,
      stockPercentage: 0,
      bondPercentage: 0,
      goldPercentage: 0,
      weights: {
        stock: 0,//股票权重
        bond: 0,//债券权重
        fund: 0//基金权重
      },
      metrics: {
        portfolioReturn: 0,//组合预期收益率（%）
        portfolioVolatility: 0,//组合波动率（%）
        sharpeRatio: 0//夏普比率
      },
      //模型数学结果（理论结合-参考值）
      compliancePreview: {
        bondFloor: 0,
        compliantWeights: {
          stock: 0,//股票权重
          bond: 0,//债券权重
          fund: 0//基金权重
        },
        message: '',
        redistributionNote: '',
        riskLevel: '',
        stockCap: '',
        triggered: false
      },
      warningMsg: '',
      loading: false,
      currentRiskLevel: 'C3'
    }
  },
  created () {
    // 优先从 localStorage 获取已保存的参数（支持跨标签页共享）
    const savedParams = localStorage.getItem('modelParams')
    if (savedParams) {
      try {
        const params = JSON.parse(savedParams)
        this.riskFreeRate = params.riskFreeRate
        this.stockReturn = params.stockReturn
        this.riskAversion = params.riskAversion
        this.weights = params.weights
        this.metrics = params.metrics
        return
      } catch (e) {
        console.error('解析 modelParams 失败:', e)
      }
    }

    // modelParams 无值 → 根据 riskResult 风险等级 + 当前 activeTab 匹配默认参数
    this.applyRiskBasedDefaults()
  },
  watch: {
    loading (val) {
      localStorage.setItem('model_loading', JSON.stringify({ visible: val }))
    },
    activeTab: {
      handler (newVal, oldVal) {
        console.log('activeTab changed from', oldVal, 'to', newVal)
        // 每次切换标签，都根据风险等级+模型重新应用默认参数
        this.applyRiskBasedDefaults()
        // 切换模型调接口获取实时配置
        this.updateAllocations()
      },
      immediate: true
    }
  },
  computed: {
    showRiskFreeRate () {
      if (this.activeTab !== 'EqualWeight') {
        return true
      } else {
        return false
      }
    },
    showStockReturn () {
      if (this.activeTab === 'MeanVariance' || this.activeTab === 'BlackLitterman') {
        return true
      } else {
        return false
      }
    },
    showRiskAversion () {
      if (this.activeTab === 'MeanVariance' || this.activeTab === 'RiskParity' || this.activeTab === 'BlackLitterman') {
        return true
      } else {
        return false
      }
    },
    currentRating () {
      const ratingMap = {
        C1: { code: 'C1', label: '保守型' },
        C2: { code: 'C2', label: '稳健型' },
        C3: { code: 'C3', label: '平衡型' },
        C4: { code: 'C4', label: '积极型' },
        C5: { code: 'C5', label: '激进型' }
      }
      return ratingMap[this.currentRiskLevel] || ratingMap.C3
    },
    riskAversionLabel () {
      if (this.riskAversion <= 3) return '激进'
      if (this.riskAversion <= 7) return '偏中'
      return '保守'
    }
  },
  mounted () {
    // 强制重置 loading，防止上一轮异常残留导致卡死
    this.loading = false
    localStorage.removeItem('model_loading')
    // 添加 localStorage 变化监听（用于接收主屏的操作同步）
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy () {
    this.loading = false
    localStorage.removeItem('model_loading')
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    handleStorageChange (event) {
      // 监听 localStorage 变化，同步主屏的参数变化
      if (event.key === 'modelParams') {
        const params = JSON.parse(event.newValue)
        this.riskFreeRate = params.riskFreeRate
        this.stockReturn = params.stockReturn
        this.riskAversion = params.riskAversion
        this.weights = params.weights
        this.metrics = params.metrics
        if (params.compliancePreview) {
          this.compliancePreview = params.compliancePreview
        }
      } else if (event.key === 'model_loading' && event.newValue) {
        try {
          this.loading = JSON.parse(event.newValue).visible
        } catch (e) { /* ignore */ }
      }
    },

    syncParamsToStorage () {
      // 将参数同步到 localStorage，让副屏可以收到通知
      localStorage.setItem('modelParams', JSON.stringify({
        riskFreeRate: this.riskFreeRate,
        stockReturn: this.stockReturn,
        riskAversion: this.riskAversion,
        weights: this.weights,
        metrics: this.metrics,
        compliancePreview: this.compliancePreview
      }))
    },

    // ──────── 风险等级 + 模型标签 → 默认参数 ────────

    getRiskBasedConfig (riskType, tab) {
      // riskType: "C1"~"C5", tab: 当前选中的模型标签
      const configMap = {
        C1: {
          MinVariance: { riskFreeRate: 2.5 },
          RiskParity: { riskFreeRate: 2.5, riskAversion: 8.0 },
          MeanVariance: { riskFreeRate: 2.5, stockReturn: -5.0, riskAversion: 8.0 },
          BlackLitterman: { riskFreeRate: 2.5, stockReturn: -5.0, riskAversion: 8.0 }
        },
        C2: {
          RiskParity: { riskFreeRate: 2.5, riskAversion: 6.0 },
          MinVariance: { riskFreeRate: 2.5 },
          MeanVariance: { riskFreeRate: 2.5, stockReturn: -2.0, riskAversion: 6.0 },
          BlackLitterman: { riskFreeRate: 2.5, stockReturn: -2.0, riskAversion: 6.0 }
        },
        C3: {
          MeanVariance: { riskFreeRate: 2.5, stockReturn: 4.0, riskAversion: 5.0 },
          BlackLitterman: { riskFreeRate: 2.5, stockReturn: 4.0, riskAversion: 5.0 },
          RiskParity: { riskFreeRate: 2.5, riskAversion: 5.0 },
          MinVariance: { riskFreeRate: 2.5 }
        },
        C4: {
          BlackLitterman: { riskFreeRate: 2.5, stockReturn: 8.0, riskAversion: 3.0 },
          MeanVariance: { riskFreeRate: 2.5, stockReturn: 5.0, riskAversion: 3.0 },
          RiskParity: { riskFreeRate: 2.5, riskAversion: 3.0 },
          MinVariance: { riskFreeRate: 2.5 }
        },
        C5: {
          MeanVariance: { riskFreeRate: 2.5, stockReturn: 10.0, riskAversion: 1.5 },
          BlackLitterman: { riskFreeRate: 2.5, stockReturn: 10.0, riskAversion: 1.5 },
          RiskParity: { riskFreeRate: 2.5, riskAversion: 1.5 },
          MinVariance: { riskFreeRate: 2.5 }
        }
      }
      return configMap[riskType]?.[tab] || { riskFreeRate: 2.5 }
    },

    applyRiskBasedDefaults () {
      const riskResultStr = localStorage.getItem('riskResult')
      if (!riskResultStr) return

      try {
        const riskResult = JSON.parse(riskResultStr)
        this.currentRiskLevel = riskResult.type || 'C3'
        const config = this.getRiskBasedConfig(riskResult.type, this.activeTab)
        if (config.riskFreeRate !== undefined) this.riskFreeRate = config.riskFreeRate
        if (config.stockReturn !== undefined) this.stockReturn = config.stockReturn
        if (config.riskAversion !== undefined) this.riskAversion = config.riskAversion
      } catch (e) {
        console.error('applyRiskBasedDefaults 失败:', e)
      }
    },

    refresh () {
      // 重置参数
      this.riskFreeRate = 0
      this.stockReturn = -10
      this.riskAversion = 1
      this.stockPercentage = 0
      this.bondPercentage = 0
      this.goldPercentage = 0
      this.weights.stock = 0
      this.weights.bond = 0
      this.weights.fund = 0
      this.metrics.portfolioReturn = 0
      this.metrics.portfolioVolatility = 0
      this.metrics.sharpeRatio = 0
    },
    updateAllocations () {
      // 优先从 localStorage 获取数据（支持跨标签页共享）
      let riskResultStr = localStorage.getItem('riskResult')
      if (!riskResultStr) {
        riskResultStr = sessionStorage.getItem('riskResult')
      }

      // 安全解析，处理 null 情况
      let riskResult = riskResultStr ? JSON.parse(riskResultStr) : null
      let params = {
        "riskLevel": riskResult?.type || "C3",
      }

      switch (this.activeTab) {
        case 'MeanVariance':
          params.model = 1
          params.parameters = {
            "riskFreeRate": this.riskFreeRate,
            "stockExpectedReturn": this.stockReturn,
            "riskAversion": this.riskAversion
          }
          break;
        case 'RiskParity':
          params.model = 2
          params.parameters = {
            "riskFreeRate": this.riskFreeRate,
            // "stockExpectedReturn": this.stockReturn,
            "riskAversion": this.riskAversion
          }
          break;
        case 'MinVariance':
          params.model = 3
          params.parameters = {
            "riskFreeRate": this.riskFreeRate,
            // "stockExpectedReturn": this.stockReturn,
            // "riskAversion": this.riskAversion
          }
          break;
        case 'BlackLitterman': // 只有在贝叶斯均值方差（Black-Litterman）模型下才需要customerProfile 参数
          params.customerProfile = riskResult?.customerProfile || {}
          params.model = 4
          params.parameters = {
            "riskFreeRate": this.riskFreeRate,
            "stockExpectedReturn": this.stockReturn,
            "riskAversion": this.riskAversion
          }
          break;
        case 'EqualWeight':
          params.model = 5
          params.parameters = {
            "riskFreeRate": 2.5,
            "stockExpectedReturn": 8,
            "riskAversion": 3
          }
          break;
      }
      // // 调用接口获取实时配置权重
      // apiOpen.ModelCalculation(params).then(res => {
      //   this.weights = res.weights
      //   this.metrics = res.metrics
      //   // 将参数同步到 localStorage，让副屏可以收到通知
      //   this.syncParamsToStorage()
      // }).catch(err => {
      //   this.$message.error(err)
      // })


      // 调用接口获取实时配置权重
      apiOpen.VisitorModelCalculation(params).then(res => {
        console.log("实时配置权重>>>", res)
        this.weights = res.weights
        this.metrics = res.metrics
        this.compliancePreview = res.compliancePreview
        this.warningMsg = res.warningMsg
        // 将参数同步到 localStorage，让副屏可以收到通知
        this.syncParamsToStorage()
      }).catch(err => {
        this.$message.error(err)
      })
    },
    confirmMakeweiciParameters () {
      // 优先从 localStorage 获取数据（支持跨标签页共享）
      let riskResultStr = localStorage.getItem('riskResult')
      if (!riskResultStr) {
        riskResultStr = sessionStorage.getItem('riskResult')
      }

      // 安全解析，处理 null 情况
      let riskResult = riskResultStr ? JSON.parse(riskResultStr) : null
      let params = {
        "riskType": riskResult?.type || "C3",
        "evaluationDate": this.formatTimeStamp('yyyy-MM-dd') || "2026-04-23",
        "modelWeights": {
          "stock": this.weights.stock,
          "bond": this.weights.bond,
          "fund": this.weights.fund,
        }
      }
      if (this.activeTab === 'MeanVariance') {
        if (this.riskFreeRate === 0 || this.stockReturn === 0 || this.riskAversion === 1) {
          this.$message.warning('请先拖动选择参数!')
          return
        }

      } else if (this.activeTab === 'RiskParity') {
        if (this.riskFreeRate === 0 || this.riskAversion === 1) {
          this.$message.warning('请先拖动选择参数!')
          return
        }
      }
      else if (this.activeTab === 'MinVariance') {
        if (this.riskFreeRate === 0) {
          this.$message.warning('请先拖动选择参数!')
          return
        }
      }
      else if (this.activeTab === 'BlackLitterman') {
        if (this.riskFreeRate === 0 || this.stockReturn === 0 || this.riskAversion === 1) {
          this.$message.warning('请先拖动选择参数!')
          return
        }
      }
      this.loading = true
      this.runAudio()
      apiOpen.RecommendPortfolio(params).then(res => {
        if (res) {
          this.loading = false

          localStorage.setItem('recommendResult', JSON.stringify(res))
          localStorage.setItem('modelName', this.activeTab)
          localStorage.setItem('modelWeights', JSON.stringify({
            "stock": this.weights.stock,
            "bond": this.weights.bond,
            "fund": this.weights.fund,
          }))
          //清除旧的推荐结果
          localStorage.removeItem('NewrecommendResult')
          this.$router.push({ name: 'Tiaozhengzichanbili' })


        }
      }).catch(err => {
        console.log(err)
        this.loading = false
        this.$message.error(err)
      })
    },
    // 播放音频
    runAudio () {
      this.playOnceAudio('/系统正在构建专属资产配置方案，预计约35秒，请稍候.mp3')
    }
  }
}
</script>

<style scoped>
.makeweici-model {
  width: 100%;
}

.model-content {
  display: flex;
  gap: 24px;
  width: 100%;
}

.left-panel {
  flex: 3;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.right-panel {
  flex: 7;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.panel-title {
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  margin: 0;
}

.risk-rating {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #3b82f6;
  padding: 4px 12px;
  background: #eff6ff;
  border-radius: 20px;
}

.rating-icon {
  width: 14px;
  height: 14px;
}

.parameter-group {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.parameter-note {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e2e8f0;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.6;
}

.note-icon {
  font-weight: 500;
}

.parameter-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.parameter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.parameter-name {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
}

.parameter-value {
  font-size: 14px;
  font-weight: 600;
  color: #3b82f6;
}

.slider-container {
  margin-top: 8px;
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
  color: #94a3b8;
}

.button-group {
  margin-top: 32px;
  display: flex;
  justify-content: flex-start;
}

.reset-btn {
  border-radius: 8px;
}

.preview-content {
  display: flex;
  align-items: stretch;
  /* gap: 20px; */
  /* padding: 16px 0; */
}

.preview-column {
  flex: 1;
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px 0;
  min-width: 0;
  overflow: hidden;
}

.column-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.column-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.status-badge {
  font-size: 11px;
  padding: 2px 0px;
  border-radius: 10px;
  background: #f1f5f9;
  color: #64748b;
}

.status-badge.warning {
  background: #fef3c7;
  color: #d97706;
}

.status-badge.error {
  background: #feeff1;
  color: #dd0708;
}

.status-badge.success {
  background: #d1fae5;
  color: #059669;
}

.desc {
  font-size: 12px;
  color: #94a3b8;
  margin: -10px 0 12px 0;
  line-height: 1.4;
}

.donut-row {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 8px;
}

.donut-chart-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  position: relative;
}

.donut-chart {
  width: 80px;
  height: 80px;
  transform: rotate(-90deg);
}

.donut-chart circle {
  transition: stroke-dashoffset 0.5s ease;
}

.donut-center {
  position: absolute;
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
}

.weight-bar-stacked {
  margin-top: 12px;
}

.weight-bar-track {
  display: flex;
  height: 10px;
  background: #e2e8f0;
  border-radius: 5px;
  overflow: hidden;
  gap: 2px;
}

.weight-bar-segment {
  height: 100%;
  border-radius: 4px;
  transition: width 0.5s ease;
  min-width: 4px;
}

.weight-bar-segment.stock {
  background: #3b82f6;
}

.weight-bar-segment.bond {
  background: #10b981;
}

.weight-bar-segment.fund {
  background: #f59e0b;
}

.weight-bar-labels {
  display: flex;
  justify-content: space-around;
  margin-top: 6px;
}

.weight-bar-label {
  font-size: 12px;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 4px;
}

.label-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.label-dot.stock {
  background: #3b82f6;
}

.label-dot.bond {
  background: #10b981;
}

.label-dot.fund {
  background: #f59e0b;
}

.compliance-arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 4px;
  position: relative;
  flex-shrink: 0;
}

.arrow-dashes {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: repeating-linear-gradient(to bottom,
      #cbd5e1 0px,
      #cbd5e1 6px,
      transparent 6px,
      transparent 12px);
}

.arrow-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  z-index: 1;
}

.arrow-icon {
  font-size: 28px;
  color: #3b82f6;
}

.arrow-text {
  font-size: 11px;
  color: #64748b;
}

.compliance-tips {
  display: flex;
  gap: 10px;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border-radius: 10px;
  padding: 12px 14px;
  margin: 0;
  border-left: 4px solid #f59e0b;
}

.tip-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.tip-content {
  flex: 1;
}

.tip-title {
  font-size: 12px;
  font-weight: 600;
  color: #d97706;
  margin-bottom: 4px;
}

.tip-text {
  font-size: 12px;
  color: #92400e;
  line-height: 1.4;
}

.metrics-cards {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.metric-card {
  flex: 1;
  padding: 12px;
  border-radius: 10px;
  text-align: center;
}

.metric-card.blue {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
}

.metric-card.green {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
}

.metric-card.orange {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
}

.metric-label {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 6px;
}

.metric-value {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.metric-value-blue {
  color: #034df9;
}

.metric-value-green {
  color: #079b4f;
}

.metric-value-orange {
  color: #fea90e;
}

.ai-note {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  font-size: 12px;
  color: #64748b;
  margin-top: 16px;
}

.ai-note i {
  color: #3b82f6;
}

/* 横屏适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .model-content {
    gap: 16px;
  }

  .left-panel,
  .right-panel {
    padding: 16px;
  }

  .panel-title {
    font-size: 18px;
  }

  .parameter-name,
  .parameter-value {
    font-size: 14px;
  }

  .chart-bars {
    height: 160px;
  }

  .bar {
    width: 80px;
  }

  .bar-value {
    font-size: 16px;
  }

  .table-cell {
    font-size: 18px;
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .makeweici-model {
    padding: 20px 16px;
    /* min-height: 100vh; */
    background: linear-gradient(180deg, #f0f4ff 0%, #faf5ff 50%, #f0f9ff 100%);
  }

  .model-content {
    flex-direction: column;
    gap: 5px;
  }

  .left-panel {
    /* display: none; */
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(99, 102, 241, 0.08);
  }



  .right-panel {
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .panel-title {
    font-size: 16px;
    font-weight: 600;
    /* color: #1e293b; */
    margin-bottom: 8px;
  }

  .parameter-group {
    gap: 16px;
  }

  .parameter-item {
    padding: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 10px;
    border: 1px solid rgba(99, 102, 241, 0.08);
    gap: 0px;
  }

  .panel-header {
    margin-bottom: 4px;
  }

  .parameter-header {
    margin-bottom: 0px;
  }

  .parameter-name {
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
  }

  .parameter-value {
    font-size: 14px;
    font-weight: 600;
    color: #6366f1;
  }

  .slider-container {
    margin-top: 0px;
  }

  .slider-labels {
    margin-top: 8px;
  }

  .slider-labels span {
    font-size: 11px;
    color: #94a3b8;
  }

  .chart-bars {
    height: 120px;
    padding: 16px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 12px;
    border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .bar-item {
    gap: 8px;
  }

  .bar {
    width: 60px;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .stock-bar {
    background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
  }

  .bond-bar {
    background: linear-gradient(180deg, #10b981 0%, #059669 100%);
  }

  .gold-bar {
    background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
  }

  .bar-value {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
  }

  .bar-label {
    font-size: 12px;
    color: #64748b;
    margin-top: 6px;
  }

  .preview-table {
    gap: 12px;
    padding: 16px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 12px;
    border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .table-row {
    gap: 12px;
  }

  .table-cell {
    padding: 10px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
  }

  .stock-cell {
    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
    color: #2563eb;
  }

  .bond-cell {
    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
    color: #059669;
  }

  .gold-cell {
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    color: #d97706;
  }

  .table-labels {
    gap: 12px;
  }

  .table-label {
    font-size: 11px;
    color: #64748b;
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {

  .left-panel,
  .right-panel {
    padding: 16px;
    border-radius: 8px;
  }

  .panel-title {
    font-size: 14px;
  }

  .column-header {
    height: 40px;
  }

  .parameter-name,
  .parameter-value {
    font-size: 11px;
  }

  .chart-bars {
    height: 80px;
  }

  .bar {
    width: 40px;
  }

  .bar-value {
    font-size: 12px;
  }

  .table-cell {
    font-size: 14px;
    padding: 8px;
  }

  .ai-note {
    font-size: 10px;
    padding: 8px;
  }
}
</style>
